import { DataBusEffects } from './dataBus.effects';

export const effects: any[] = [DataBusEffects];
